/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Plan_Change_Pending_ItemsInputs */

const en_plan_change_pending_items = /** @type {(inputs: Plan_Change_Pending_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Includes ${i?.amount} of pending adjustments from an earlier change.`)
};

const es_plan_change_pending_items = /** @type {(inputs: Plan_Change_Pending_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incluye ${i?.amount} de ajustes pendientes de un cambio anterior.`)
};

/**
* | output |
* | --- |
* | "Includes {amount} of pending adjustments from an earlier change." |
*
* @param {Plan_Change_Pending_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_pending_items = /** @type {((inputs: Plan_Change_Pending_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Pending_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_pending_items(inputs)
	return en_plan_change_pending_items(inputs)
});